import { __generator } from "tslib";
import { get, throttle } from 'lodash-es';
import { select, takeEvery } from 'redux-saga/effects';
import * as actionCreators from '../actionCreators';
import * as actionTypes from '../constants/actionTypes';
import * as pusherConstants from '../constants/pusher';
import { connect } from '../services/pusher';
import { updateHotspot } from '../updateProjectConfig';
var projectActions = [
    actionTypes.LOAD_FULL_PROJECT_DONE,
    actionTypes.LOAD_PROJECT_PREVIEW_DONE,
    actionTypes.SET_PROJECT,
];
export default function pusherSaga(dispatch) {
    var projectID, channel, unsubscribe, origProjectConfig;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(projectActions, function (_a) {
                    var channelName, isDownloaded, loadFullProjectThrottled_1;
                    var _b;
                    var projectConfig = _a.project;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                channelName = projectConfig.pusherChannel;
                                return [4 /*yield*/, select(function (state) { return state.project.isDownloaded; })];
                            case 1:
                                isDownloaded = _c.sent();
                                if (!channelName || isDownloaded) {
                                    return [2 /*return*/];
                                }
                                (origProjectConfig = projectConfig.origProjectConfig);
                                if (projectID !== projectConfig.numericID) {
                                    projectID = projectConfig.numericID;
                                    if (unsubscribe) {
                                        unsubscribe();
                                    }
                                    (_b = connect(channelName), channel = _b.channel, unsubscribe = _b.unsubscribe);
                                    channel.bind(pusherConstants.EVENT_HOTSPOT, function (res) {
                                        var hotspot = get(res, 'content.object');
                                        if (hotspot) {
                                            dispatch(actionCreators.setProject(updateHotspot(origProjectConfig, hotspot)));
                                        }
                                    });
                                    loadFullProjectThrottled_1 = throttle(function () {
                                        dispatch(actionCreators.loadFullProject(projectConfig.id));
                                    }, 5000, { trailing: true });
                                    channel.bind(pusherConstants.EVENT_CONTENT_UPDATED, function () {
                                        // TODO: smart update
                                        loadFullProjectThrottled_1();
                                    });
                                    channel.bind(pusherConstants.EVENT_CONTENT_CREATED, function () {
                                        // TODO: smart update
                                        loadFullProjectThrottled_1();
                                    });
                                }
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
